const ingredientElements = document.getElementsByClassName('ingredient-wrapper');

function closeAllExcept(exceptionEl) {
  Array.from(ingredientElements).forEach((el) => {
    if (exceptionEl && el === exceptionEl) return;
    const itemDescription = el.querySelector('p.ingredient-item-description');
    if (itemDescription) {
      itemDescription.classList.remove('hidden');
      itemDescription.style.maxHeight = '0px';
      itemDescription.style.opacity = '0';
    }
    el.classList.remove('is-open');
  });
}

Array.from(ingredientElements).forEach((wrapper) => {
  const itemDescription = wrapper.querySelector('p.ingredient-item-description');
  if (!itemDescription) return;

  wrapper.classList.remove('is-open');
  itemDescription.classList.remove('hidden');
  itemDescription.style.maxHeight = '0px';
  itemDescription.style.opacity = '0';

  wrapper.addEventListener('click', function () {
    const isClosed = !wrapper.classList.contains('is-open');
    closeAllExcept(wrapper);

    if (isClosed) {
      wrapper.classList.add('is-open');

      itemDescription.classList.remove('hidden');
      itemDescription.style.maxHeight = itemDescription.scrollHeight + 'px';
      itemDescription.style.opacity = '1';

      const onTransitionEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        if (!wrapper.classList.contains('is-open')) return;
        itemDescription.style.maxHeight = 'none';
        itemDescription.removeEventListener('transitionend', onTransitionEnd);
      };
      itemDescription.addEventListener('transitionend', onTransitionEnd);
    } else {
      if (itemDescription.style.maxHeight === 'none') {
        itemDescription.style.maxHeight = itemDescription.scrollHeight + 'px';
        itemDescription.offsetHeight;
      }
      itemDescription.style.maxHeight = '0px';
      itemDescription.style.opacity = '0';
      wrapper.classList.remove('is-open');
    }
  });
});
